import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight } from 'lodash';
import { connect } from '../../../common/components/runtime-context';
import withTranslate from '../../../common/components/with-translate/with-translate';
import EmptyStates from '../empty-states';
import Button from '../button';
import ButtonGroup from '../button-group';
import ensureAuth from '../../hoc/ensure-auth';
import withDeviceType from '../../hoc/with-device-type';
import { getForumTitle } from '../../../common/selectors/forum-data-selectors';

const ButtonSecure = ensureAuth(Button);

class NotLoggedInWithPlansEmptyState extends Component {
  render() {
    const { buttonClicked, navigateToPaidPlans, isDesktop, t, forumTitle } = this.props;

    return (
      <EmptyStates
        title={t('not-logged-in-with-plans-empty-state.title', { forumTitle })}
        content={t('not-logged-in-with-plans-empty-state.content')}
        type="specific_members_paid_plans"
      >
        <ButtonGroup
          primaryButtonText={t('not-logged-in-with-plans-empty-state.see-plans')}
          primaryButtonProps={{
            isSmall: isDesktop,
            onClick: navigateToPaidPlans,
          }}
          secondaryButtonComponent={ButtonSecure}
          secondaryButtonText={t('not-logged-in-with-plans-empty-state.login')}
          secondaryButtonProps={{
            requestLoginMode: 'login',
            isSmall: isDesktop,
            beforeRequestLogin: () => buttonClicked('login'),
          }}
        />
      </EmptyStates>
    );
  }
}

NotLoggedInWithPlansEmptyState.propTypes = {
  navigateToPaidPlans: PropTypes.func,
  buttonClicked: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  t: PropTypes.func,
  forumTitle: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
};

const mapRuntimeToProps = (state, { returnTo, paidPlanIds, t, categoryId }, actions) => ({
  navigateToPaidPlans: () =>
    actions.navigateToPaidPlans(
      returnTo,
      paidPlanIds,
      t('paid-plans-vertical-status-content.title'),
      t(
        paidPlanIds
          ? 'paid-plans-vertical-status-content.back-to-category'
          : 'paid-plans-vertical-status-content.back-to-forum',
      ),
      categoryId,
    ),
  buttonClicked: (type) => actions.buttonClicked({ name: 'all-categories-hidden', type }),
  forumTitle: getForumTitle(state),
});

export default flowRight(
  withTranslate,
  connect(mapRuntimeToProps),
  withDeviceType,
)(NotLoggedInWithPlansEmptyState);
